import React, { useEffect, useState } from 'react'
import Table from '../../../../../../common/components/table-manager/v1.1/table';

export default function StopsInfoComponent({ libraryData, stopDetails, transporters, agents, orderDetails, tripsDetails, getShippingType, ConvertMinutes }: any) {

    const [
        columnDefs,
        setColumnDefs
    ] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'RoutePlanStopId', headerName: 'Stop Id', sortable: true },
            {
                field: 'RoutePlanStopTypeId', headerName: 'StopType',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.RoutePlanStopType, isRowColorDecider: false },
                sortable: true,
                filter: false
            },
            {
                field: 'LogisticsStopStatusId', headerName: 'Stop Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: {
                    library: libraryData?.result?.LogisticsStopStatus, isRowColorDecider: true
                },
                sortable: true,
                filter: false
            },

            { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
        ]);
    }

    useEffect(() => {
        createColumnDefs()

    }, [stopDetails])
    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={stopDetails}
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Name',
                }}
                enableFilter={true}
                headingName="" />
        </>
    )
}